// Tiny GA4 helper. Safe no-op if gtag isn't loaded.
export const gaEvent = (name, params = {}) => {
    if (typeof window === "undefined") return;
    try {
        if (typeof window.gtag === "function") {
            window.gtag("event", name, params);
        }
    } catch (err) {
        // Analytics must never break a user flow. We swallow the error but
        // record it so a monitoring tool or the browser console can surface
        // repeated failures. Do not surface a toast; analytics is not
        // user-facing.
        if (typeof console !== "undefined" && console.warn) {
            console.warn("[analytics] gtag event dispatch failed:", name, err);
        }
    }
};

// Mark these as GA4 conversions in: Admin → Events → toggle "Mark as conversion".
export const CONVERSION_EVENTS = {
    BOOKING_SUBMIT: "submit_booking_form",
    CONTACT_SUBMIT: "submit_contact_form",
    QUOTE_REQUEST: "request_quote",
    GUIDE_DOWNLOAD: "guide_download",
    EMAIL_CLICK: "email_click",
    PHONE_CLICK: "phone_click",
};
